import { vendorStatus, syncStatus } from '../action/Status';

const initialData = {
	token: null,
	vendor: [],
	customer: [],
	vendorStatus: [],
	deleteStatus: [],
	editStatus: [],
	vendorUpdate: [],
	authenticate: false,
	authenticating: false,
	loading: false,
	error: null,
	message: '',
	vendorData: [],
	syncDescription: null,
	syncStock: null,
};

const reducer = (state = initialData, action) => {
	console.log(action);
	switch (action.type) {
		case vendorStatus.vendor_REQUEST:
			state = {
				...state,
				authenticating: true,
			};
			break;
		case vendorStatus.vendor_SUCCESS:
			state = {
				...state,
				vendor: action.payload.dt,
				authenticate: true,
				authenticating: false,
			};
			break;

		case vendorStatus.vendor_STATUS_REQUEST:
			state = {
				...state,
				authenticate: true,
				authenticating: false,
			};
			break;
		case vendorStatus.vendor_STATUS_SUCCESS:
			state = {
				...state,
				vendorStatus: action.payload.statusData,
				authenticate: true,
				authenticating: false,
			};
			break;

		case vendorStatus.vendor_DELETE_REQUEST:
			state = {
				...state,
				authenticate: true,
				authenticating: false,
			};
			break;
		case vendorStatus.vendor_DELETE_SUCCESS:
			state = {
				...state,
				deleteStatus: action.payload.deleteStatus,
				authenticate: true,
				authenticating: false,
			};
			break;

		case vendorStatus.vendor_EDIT_REQUEST:
			state = {
				...state,
				authenticate: true,
				authenticating: false,
			};
			break;
		case vendorStatus.vendor_EDIT_SUCCESS:
			state = {
				...state,
				editStatus: action.payload.editStatus,
				authenticate: true,
				authenticating: false,
			};
			break;

		case vendorStatus.vendor_UPDATE_REQUEST:
			state = {
				...state,
				authenticate: true,
				authenticating: false,
			};
			break;
		case vendorStatus.vendor_UPDATE_SUCCESS:
			state = {
				...state,
				vendorUpdate: action.payload.vendorUpdate,
				authenticate: true,
				authenticating: false,
			};
			break;

		case vendorStatus.vendor_ADD_SUCCESS:
			state = {
				...state,
				vendorUpdate: action.payload.vendorUpdate,
				authenticate: true,
				authenticating: false,
			};
			break;

		case vendorStatus.vendor_BULK_REQUEST:
			state = {
				...state,
				authenticate: true,
				authenticating: false,
			};
			break;
		case vendorStatus.vendor_BULK_SUCCESS:
			state = {
				...state,
				authenticate: true,
				authenticating: false,
			};
			break;
		case syncStatus.SYNC_DESCRIPTION_FAILED:
			state = {
				...state,
				syncDescription: null,
			};
			break;
		case syncStatus.SYNC_DESCRIPTION_REQUEST:
			state = {
				...state,
				syncDescription: true,
			};
			break;
		case syncStatus.SYNC_DESCRIPTION_SUCCESS:
			state = {
				...state,
				syncDescription: false,
			};
			break;
		case syncStatus.SYNC_STOCK_FAILED:
			state = {
				...state,
				syncStock: null,
			};
			break;
		case syncStatus.SYNC_STOCK_REQUEST:
			state = {
				...state,
				syncStock: true,
			};
			break;
		case syncStatus.SYNC_STOCK_SUCCESS:
			state = {
				...state,
				syncStock: false,
			};
			break;

		case vendorStatus.customer_REQUEST:
			state = {
				...state,
				authenticating: true,
			};
			break;
		case vendorStatus.customer_SUCCESS:
			state = {
				...state,
				customer: action.payload.dt,
				authenticate: true,
				authenticating: false,
			};
			break;

		default:
			return state;
	}

	return state;
};

export default reducer;
